import { UIHeading1, Body1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './BrokerConsultantBanner.css';
import { NO_BREAK_SPACE } from '../../constants/symbolsUnicode';

interface IBrokerConsultantBannerProps {
  button: React.ReactNode;
}

export const BrokerConsultantBanner: React.FC<IBrokerConsultantBannerProps> = ({ button }) => {
  return (
    <section className={styles['container']} data-testid="BrokerBanner">
      <div className={styles['inner']}>
        <UIHeading1>
          Подберём и{NO_BREAK_SPACE}поможем купить квартиру в{NO_BREAK_SPACE}новостройке. Бесплатно!
        </UIHeading1>
        <div className={styles['description-wrapper']}>
          <Body1>
            Найдём тот{NO_BREAK_SPACE}самый вариант под{NO_BREAK_SPACE}ваш{NO_BREAK_SPACE}бюджет
          </Body1>
        </div>
        <div>{button}</div>
      </div>
    </section>
  );
};
